import { render } from "./qlc-kua.vue?vue&type=template&id=0dd5e9e8&scoped=true"
import script from "./qlc-kua.vue?vue&type=script&lang=js"
export * from "./qlc-kua.vue?vue&type=script&lang=js"

import "./qlc-kua.vue?vue&type=style&index=0&id=0dd5e9e8&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd5e9e8"]])

export default __exports__